__turbopack_context__.v({
  "brandLogo": "AuthLayout-module__QypKUG__brandLogo",
  "formContainer": "AuthLayout-module__QypKUG__formContainer",
  "textClaim": "AuthLayout-module__QypKUG__textClaim",
  "wFormContainer": "AuthLayout-module__QypKUG__wFormContainer",
});
